import { api } from "@/api/client";
import type {
  CreateUserPayload,
  EditUserPayload,
  ResetUserPasswordResponse,
} from "@/api/mutations/users/types";
import { queryKeys } from "@/api/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useEditUser = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: EditUserPayload) =>
      api.put(`/admin/user/${id}`, payload).then((res) => res.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.getUsers] });
    },
  });
};

export const useResetUserPassword = (id: number) => {
  return useMutation({
    mutationFn: () =>
      api
        .put<ResetUserPasswordResponse>(`/admin/reset-user-password/${id}`)
        .then((res) => res.data),
  });
};

export const useCreateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateUserPayload) =>
      api.post("/admin/create-user", payload).then((res) => res.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.getUsers] });
    },
  });
};
